<bootstrap-popup [id]="'createMessageDialog'" [title]="'R&eacute;diger un message collationn&eacute;'" [displaySubject]="displaySubject">
	<form role="form" class="form-horizontal">
		<div class="row">
			<div class="col-md-12">
				<div class="form-group">
					<label for="choixMessage" class="col-md-2 plus-half control-label">Message existant&nbsp;:</label>
					<div class="col-md-7 plus-half">
						<filterable-select
							[id]="'choixMessage'"
							[inputClass]="'form-control'"
							[list]="availableMessages"
							[labelGetter]="getMessageLabel"
							[selectedItem]="selectedOldMessage"
							(selectedItemChange)="onSelectOldMessage($event)"
							>
						</filterable-select>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="panel panel-default">
					<div class="panel-heading ">
						<h3>Vous</h3>
					</div>
					<div *ngIf="user && message" class="panel-body">
						<div class="form-group row">
							<div class="form-group">
								<label class="col-md-3 control-label" for="choixER">&nbsp;</label>
								<div class="col-md-9">
									<label class="radio-inline" *ngFor="let option of emetteurOptions">
										<input type="radio"
											name="choixER"
											[id]="'choixER_' + option.value"
											[value]="option.value"
											[(ngModel)]="message.emetteur"
											(ngModelChange)="onEmetteurChange($event)"
										/>
										{{ option.label }}
									</label>
								</div>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-3 control-label" for="nomAgent">Nom&nbsp;:</label>
							<div class="col-sm-9">
								<input id="nomAgent" name="nomAgent"
									type="text"
									class="form-control"
									disabled="disabled"
									[(ngModel)]="user.firstName"
									/>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-3 control-label" for="prenomAgent">Pr&eacute;nom&nbsp;:</label>
							<div class="col-sm-9">
								<input id="prenomAgent" name="prenomAgent"
									type="text"
									class="form-control"
									disabled="disabled"
									[(ngModel)]="user.lastName"
									/>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-3 control-label" for="fonctionAgent">Fonction&nbsp;:</label>
							<div class="col-sm-9">
								<input id="fonctionAgent" name="fonctionAgent"
									type="text"
									class="form-control"
									disabled="disabled"
									[(ngModel)]="user.role"
								/>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-3 control-label" for="entiteAgent">Entit&eacute;&nbsp;:</label>
							<div class="col-sm-9">
								<input id="entiteAgent" name="entiteAgent"
									type="text"
									class="form-control"
									disabled="disabled"
									[(ngModel)]="message.agentEntite"
								/>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-3 control-label" for="entiteAgent">N&deg;&nbsp;:</label>
							<div class="col-sm-9">
								<input id="numMessage" name="numMessage"
									type="text"
									class="form-control"
									disabled="disabled"
									[(ngModel)]="numMessage"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="panel panel-default ">
					<div class="panel-heading">
						<h3>Votre correspondant</h3>
					</div>
					<div *ngIf="message" class="panel-body">
						<div class="form-group row" style="visibility: hidden">
							<div class="form-group">
								<label class="col-md-3 control-label">&nbsp;</label>
								<div class="col-md-9">
									<label class="radio-inline">
										<input type="radio"
											[value]="'x'"
										/>
										&nbsp;
									</label>
								</div>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-3 control-label" for="nomCorrespondant">Nom&nbsp;:</label>
							<div class="col-sm-9">
								<input id="nomCorrespondant" name="nomCorrespondant"
									type="text" [maxLength]="255" 
									class="form-control"
									[(ngModel)]="message.correspondantNom"
								/>
							</div>
						</div>
						<div class="form-group row" style="visibility: hidden">
							<label class="col-sm-3 control-label"></label>
							<div class="col-sm-9">
								<input class="form-control" type="text"/>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-3 control-label" for="fonctionCorrespondant">Fonction&nbsp;:</label>
							<div class="col-sm-9">
								<input id="fonctionCorrespondant" name="fonctionCorrespondant"
									type="text" [maxLength]="255" 
									class="form-control"
									[(ngModel)]="message.correspondantFonction"
								/>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-3 control-label" for="eniteCorrespondant">Entit&eacute;&nbsp;:</label>
							<div class="col-sm-9">
								<input id="entiteCorrespondant" name="entiteCorrespondant"
									type="text" [maxLength]="255" 
									class="form-control"
									[(ngModel)]="message.correspondantEntite"
								/>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-3 control-label" for="numCorrespondant">N&deg;&nbsp;:</label>
							<div class="col-sm-9">
								<input id="numCorrespondant" name="numCorrespondant"
									type="text" [maxLength]="255" 
									class="form-control"
									[(ngModel)]="message.correspondantNum"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-12">
				<div class="panel panel-default">
					<div class="panel-heading">
						<h3>Le message</h3>
					</div>
					<div *ngIf="message" class="panel-body">
						<div class="form-group row">
							<label class="col-md-2 control-label" style="padding-top: 28px">Date&nbsp;:</label>
							<div class="col-md-1" style="padding-top: 28px">{{ message.dateMessage | displayLocalDate }}</div>
							<label class="col-md-2 control-label" style="padding-top: 28px" for="dateMessage">Heure&nbsp;:</label>
							<div class="col-md-4" *ngIf="time">
								<basic-timepicker
									[(time)]="time"
									(timeChange)="onTimeChange($event)"
									>
								</basic-timepicker>
							</div>
						</div>
						<div class="form-group row">
							<div class="form-group">
								<label class="col-md-2 control-label" for="choixEtatParc">Etat du parc&nbsp;:</label>
								<div class="col-md-9">
									<label class="radio-inline" *ngFor="let option of parcOptions">
										<input type="radio"
											name="choixEtatParc"
											[id]="'choixEtatParc_' + option.value"
											[value]="option.value"
											[(ngModel)]="parcEnExploitation"
										/>
										{{ option.label }}
									</label>
								</div>
							</div>
						</div>
						<div class="form-group row" *ngIf="user && parcEnExploitation">
							<parc-multi-selector
								[id]="'choixParcs'"
								[labelClass]="'col-md-2'"
								[fieldClass]="'col-md-9'"
								[antenneId]="user.antenneId"
								[clearCommands]="clearParcsCommands"
								(selectedParcIdsChange)="onParcIdsChange($event)"
								>
							</parc-multi-selector>
						</div>
						<div class="form-group row" *ngIf="user && !parcEnExploitation">
							<label class="col-md-2 control-label">Parc en construction&nbsp;:</label>
							<div class="col-sm-9">
								<suggestable-input
									[inputClass]="'form-control'"
									[suggestionsObservableGetter]="getParcsEnConstructionSuggestionObservable"
									[(value)] = "message.parcEnConstruction"
									>
								</suggestable-input>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-md-2 control-label" for="message">Objet du message&nbsp;:</label>
							<div class="col-md-9">
								<textarea id="message" name="message"
									rows="5"
									maxlength="255"
									style="width: 100%"
									[(ngModel)]="message.message"
									>
								</textarea>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-12">
				<div class="form-group text-center">
					<button
						type="button"
						class="btn btn-default"
						style="margin-right: 6px"
						(click)="onCancelRequested()"
						>
						Annuler
					</button>
					<button
						type="button"
						class="btn btn-success"
						(click)="onCreate()"
						>
						Valider
					</button>
				</div>
			</div>
		</div>
	</form>
</bootstrap-popup>